<template>
  <div class="app-container" v-show="isLogin">
    <!-- 理赔列表 -->
    <div style="text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        <div>
          申请时间：
          <el-date-picker
            v-model="zzc_startDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="起始时间"
            :picker-options="zzc_pickerOptionsStart"
          ></el-date-picker>
          <span class="el-range-separator">至</span>
          <el-date-picker
            v-model="zzc_endDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
            :picker-options="zzc_pickerOptionsEnd"
          ></el-date-picker>
        </div>
        <div>
          订单号：<el-input
            v-model="listQuery.order_no"
            style="width: 13vw"
            class="filter-item"
            @keyup.enter.native="handleFilter"
            clearable
          />
        </div>
        <div>
          <el-button
            type="primary"
            style="
              font-size: 12px;
              background-color: #0850fc;
              color: white;
              height: 34px;
              border-radius: 0.5em;
              padding: 10px 12px;
            "
            @click="handleFilter"
            >查询</el-button>
        </div>
      </div>
      <div class="status-tabs">
        <span 
          v-for="item in statusOptions" 
          :key="item.value" 
          :style="{ color: listQuery.status === item.value ? '#409EFF' : '#666', cursor: 'pointer', borderBottom: listQuery.status === item.value ? '2px solid #409EFF' : 'none' }"
          @click="handleStatusChange(item.value)"
        >
          {{ item.label }}
        </span>
      </div>

      <el-table
        v-loading="listLoading"
        :data="claimList"
        highlight-current-row
        style="color: rgb(70, 70, 70); margin-top: 10px"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '3px 0' }"
        :header-cell-style="{
          background: 'rgb(247 248 252) !important',
          color: 'rgb(140, 140, 140)  !important',
          padding: '7px 0',
        }"
      >
        <el-table-column label="申请时间" align="left" min-width="2">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.created_at">{{ formatCreatedAt(row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="中转仓订单号" min-width="2" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.extra_param1">{{ row.order && row.order.express_no || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" min-width="2.5" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.order_no">{{ row.order_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="仓库" min-width="1" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.cang">{{ row.order && row.order.cang || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="理赔金额" min-width="1" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.claim_money">{{ row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作说明" min-width="4" align="left">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="row.remarks">订单为：{{ row.order_no }} ，理赔金额：{{ row.amount }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="claimTotal > 0"
        :total="claimTotal"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.page_size"
        style="padding-top: 12px; padding-bottom: 0px; text-align: center"
        :layout="claimTotal > 0 ? 'total, prev, pager, next, jumper' : ''"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves";
import Pagination from "@/components/Pagination";
import moment from "moment";

export default {
  name: "claim",
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      isLogin: true,
      claimList: [],
      claimTotal: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        page_size: 20,
        start_time: "",
        end_time: "",
        order_no: "",
        status: "",
      },
      zzc_startDate: "",
      zzc_endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(), 23, 59, 59
      ),
      statusOptions: [
        { label: "全部", value: "" },
        { label: "理赔申请中", value: "1" },
        { label: "理赔成功", value: "2" },
        { label: "理赔失败", value: "3" },
        { label: "取消理赔", value: "4" },
      ],
      zzc_pickerOptionsStart: {
        disabledDate: (time) => {
          let zzc_endDateVal = this.zzc_endDate;
          if (zzc_endDateVal) {
            return time.getTime() > new Date(zzc_endDateVal).getTime();
          }
        },
      },
      zzc_pickerOptionsEnd: {
        disabledDate: (time) => {
          let zzc_beginDateVal = this.zzc_startDate;
          if (zzc_beginDateVal) {
            return time.getTime() < new Date(zzc_beginDateVal).getTime();
          }
        },
      },
    };
  },
  created() {
    const userToken = Cookies.get("view_userToken");
    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/zzc/claim" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
  },
  methods: {
    formatCreatedAt(v) {
        if (!v) return ''
        try {
            const d = new Date(v)
            return moment(d).format('YYYY-MM-DD HH:mm:ss')
        } catch (e) {
            return v
        }
    },
    async getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        return;
      }

      if (this.zzc_startDate == "") {
        const nowDay = new Date();
        let nm = nowDay.getMonth();
        if (nm < 10) nm = "0" + nm;
        this.listQuery.start_time =
          nowDay.getFullYear() + "-" + nm + "-" + nowDay.getDate() + " 00:00:00";
        this.zzc_startDate = this.listQuery.start_time;
      } else {
        this.listQuery.start_time = moment(this.zzc_startDate).format("YYYY-MM-DD HH:mm:ss");
      }
      
      if (this.zzc_endDate == "") {
        this.zzc_endDate = new Date().toLocaleString();
        this.listQuery.end_time = new Date().toLocaleString();
      } else {
        this.listQuery.end_time = moment(this.zzc_endDate).format("YYYY-MM-DD HH:mm:ss");
      }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/claimList";
      const token = Cookies.get("view_userToken");
      
      axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: this.listQuery,
      })
      .then((response) => {
        const resd = response.data;
        if (resd.code == "200") {
          this.claimList = resd.data.data;
          this.claimTotal = resd.data.total;
        }
        this.listLoading = false;
      })
      .catch((error) => {
        console.error("请求失败:", error);
        this.listLoading = false;
        if (JSON.stringify(error).includes("401")) {
          this.$confirm("登录信息已失效，请重新登录!", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false,
          })
          .then(() => {
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          });
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleStatusChange(status) {
      this.listQuery.status = status;
      this.handleFilter();
    },
  },
};
</script>

<style scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
}
.filter-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.status-tabs {
  margin-top: 20px; 
  margin-bottom: 15px; 
  font-size: 16px; 
  display: flex; 
  align-items: center; 
  gap: 15px;
}
.status-tabs span {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/zzc/claim.vue